import { DataCell, DataRow, DataTable, DataTableButton } from 'components/basic/DataTable';
import { saveAs } from 'file-saver';
import * as React from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { Badge, Button } from 'reactstrap';
import Toolbar from '../basic/Toolbar';
import {
    ConversionOptionValueModel,
    ConversionOptionsClient,
    CustomersMiniConversionValidationResultsClient,
    CustomersMiniConversionValidationResultsModel,
    ExecutionsClient,
    ExecutionsModel,
    GenericClient,
    IUserLoginDetailsModel,
    PoliciesMiniConversionValidationResultsClient,
    PoliciesMiniConversionValidationResultsModel,
    ContactsMiniConversionValidationResultsClient,
    ContactsMiniConversionValidationResultsModel,
    ActivitiesMiniConversionValidationResultsClient,
    ActivitiesMiniConversionValidationResultsModel,
    ConversionReportsClient,
    MiniConversionDelayedStartModel,
} from '../../client/ApiClient';
import { HubConnection, HubConnectionBuilder } from '@microsoft/signalr';
import { store } from "AppContext"
import { enqueueNotification } from "../../store/Notifications";
import CloseConfirmationModal from '../basic/modals/CloseConfirmationModal';
import * as MiniConstants from 'constants/MiniConversion';

import '../../styles/Forms.scss';
import { actionCreators } from '../../store/Select';

interface IConversionMiniDashPageProps extends RouteComponentProps<{
    conversionId: string
}> {
    currentUser: IUserLoginDetailsModel | undefined;
    options: { [key: string]: ConversionOptionValueModel } | undefined;
    getOptions: () => void;
}

interface IConversionMiniDashPageState {
    custValResults: CustomersMiniConversionValidationResultsModel[];
    polValResults: PoliciesMiniConversionValidationResultsModel[];
    conValResults: ContactsMiniConversionValidationResultsModel[];
    actValResults: ActivitiesMiniConversionValidationResultsModel[];
    hubConnection: HubConnection | null;
    executions: ExecutionsModel[];
    buttonLock: boolean;
    timeout: any;
    validationRunning: boolean;
    submitRunning: boolean;
    validationFailureModal: boolean,
    validationSuccessModal: boolean,
    submitSuccessModal: boolean,
    confirmationModal: boolean,
    status: any,
    delayedStart: MiniConversionDelayedStartModel | null,
}

type TabName = 'edit' | 'options' | 'additionaldata' | 'reports' | 'mergestagetable' | 'mergetool' | 'minidash' | '';

class ConversionMiniDashPage extends React.Component<IConversionMiniDashPageProps, IConversionMiniDashPageState>{
    private readonly conversionGenericClient: GenericClient = new GenericClient();
    private executions: ExecutionsClient = new ExecutionsClient();
    private clientDescription: string = '';
    private conversionId: string = '';
    private conversionDescription: string = '';
    private custFileSelected: boolean = false;
    private custFileUploaded: boolean = false;
    private custFileValidated: boolean = false;
    private custFileQueued: boolean = false;
    private execDescription: string = '';
    private execTitle: string = '';
    private execUserId: string = '';
    private polFileSelected: boolean = false;
    private polFileUploaded: boolean = false;
    private polFileValidated: boolean = false;
    private polFileQueued: boolean = false;
    private contFileSelected: boolean = false;
    private contFileUploaded: boolean = false;
    private contFileValidated: boolean = false;
    private contFileQueued: boolean = false;
    private actvFileSelected: boolean = false;
    private actvFileUploaded: boolean = false;
    private actvFileValidated: boolean = false;
    private actvFileQueued: boolean = false;
    private report: ConversionReportsClient = new ConversionReportsClient();


    constructor(props: Readonly<IConversionMiniDashPageProps>) {
        super(props)
        this.state = {
            custValResults: [],
            polValResults: [],
            conValResults: [],
            actValResults: [],
            hubConnection: null,
            executions: [],
            buttonLock: false,
            timeout: null,
            validationRunning: false,
            submitRunning: false,
            validationFailureModal: false,
            validationSuccessModal: false,
            submitSuccessModal: false,
            confirmationModal: false,
            status: null,
            delayedStart: null,
        }
    }
    exportToExcel = (id: string) => {
        this.report.exportToExcel(this.props.match.params.conversionId, id, null, null)
            .then(response => saveAs(response!.data, response!.fileName))
            .catch(error => { });
    }

    componentDidMount() {
        this.getExecutions()
        this.getDelayStart()
        const link = `${process.env.PUBLIC_URL}/executions`
        const hubConnection = new HubConnectionBuilder().withUrl(link).withAutomaticReconnect().build();
        this.setState({ hubConnection }, () => {
            this.state.hubConnection!
                .start()
                .then(() => console.log('Connection started!'))
                .catch(err => console.log('Error while establishing connection :('));
            this.state.hubConnection!.on('ExecutionUpdated', (execution: ExecutionsModel) => {
                let done: boolean = false;
                let pkgError: boolean = false;
                this.clientDescription = execution.clientDescription!;
                this.conversionDescription = execution.conversionDescription!;
                this.execDescription = execution.description!;
                this.execTitle = execution.title!;
                this.execUserId = execution.userId;
                if ((this.execDescription === "Succeeded" || this.execDescription === "Completed") && this.execUserId === this.props.currentUser!.id) {
                    done = true;
                }
                else if ((this.execDescription === "Failed" || this.execDescription === "Canceled" || this.execDescription === "Ended Unexpectedly" || this.execDescription === "Stopping") && this.execUserId === this.props.currentUser!.id) {
                    const color = this.execDescription === "Canceled" ? 'warning' : 'error';
                    done = true;
                    pkgError = true;
                    store.dispatch(enqueueNotification({ type: color, message: this.clientDescription + ' - ' + this.conversionDescription + ' - ' + this.execTitle + ' - ' + this.execDescription }))
                }
                this.getExecutions()
                clearInterval(this.state.timeout);
                if (done && this.state.validationRunning) {
                    if (pkgError) {
                        this.setState({ validationRunning: false });
                        this.buttonLock();
                    } else {
                        this.getValidationResults(execution);
                    }
                }
                if (done && this.state.submitRunning) {
                    this.setState({ submitRunning: false });
                    this.openSubmitSuccessModal();
                }
            });

            this.state.hubConnection!.on('ExecutionCalled', (call: string) => {
                this.getExecutions();
            });
        })
    }

    componentWillUnmount() {
        this.state.hubConnection!.stop();
    }

    buttonLock = () => {
        this.executions.listExecutionsAllTierBoolean(this.conversionId)
            .then((response) => {
                if (response) this.setState({ buttonLock: response.isLocked })
            })
            .catch(error => { })
    }

    getExecutions() {
        this.executions!.listExecutions(this.conversionId)
            .then(results => {
                this.setState({ executions: results! }, () => {
                    clearInterval(this.state.timeout);
                    this.buttonLock();
                    const miniCall = results!.filter(r => r.packageName === '00-00-01-Mini-Conversion-LoadAMS360.dtsx')
                    let lastExecution = miniCall![miniCall!.length - 1];
                    if (lastExecution) {
                        this.setState({ timeout: setInterval(() => { this.statusUpdate(lastExecution) }, 1000) });
                    }
                })
            })
            .catch(e => {
                console.log(e)
            })
    }

    getDelayStart = () => {
        this.conversionGenericClient.listMiniConversionDelayedStart(this.conversionId)
            .then(results => {
                this.setState({ delayedStart: results })
            })
            .catch(e => {
                console.log(e)
            })
    }

    statusUpdate = (lastExecution: ExecutionsModel) => {
        let dt = lastExecution!.endTime;
        if (typeof dt === 'string') {
            dt = new Date(dt);
        }
        if (typeof dt === 'object' && dt) {
            const day = dt.getDate(),
                month = dt.getMonth(),
                year = dt.getFullYear(),
                minutes = (dt.getMinutes() < 10 ? '0' : "") + dt.getMinutes();
            let hours = dt.getHours();
            const period = (hours < 12) ? 'AM' : 'PM';
            if (period === 'PM' && hours !== 12) hours = hours - 12;
            if (hours === 0) hours = 12;

            let color = ""
            const status = lastExecution.description
            if (status === "Failed" || status === "Ended Unexpectedly") {
                color = "danger"
            } else if (status === "Canceled") {
                color = "warning"
            } else if (status === "Succeeded" || status === "Completed") {
                color = "success"
            }
            clearInterval(this.state.timeout);
            this.setState({
                status: < h6 className='status' > <Badge color={color}> {lastExecution.title} completed on {
                    `${(month + 1)}/${day}/${year} ${hours}:${minutes} ${period}`
                } - Status: {lastExecution.description} </Badge></h6>
            })
        }
        else {
            const color = "primary"
            const now = new Date().valueOf();
            const estimate = lastExecution.estimatedFinish ? lastExecution.estimatedFinish!.valueOf() : 0;
            const timeLeft: string = estimate > now ? `${((estimate - now) / 60000).toFixed(2)} minutes` : 'Pending';
            const description = lastExecution.description === 'Succeeded' ? 'Running' : lastExecution.description;
            this.setState({
                status:
                    <h6 className='status'> <Badge color={color}>Estimate: {timeLeft} Status: {description} </Badge></h6>
            })
        }
    }


    getValidationResults = (exec: ExecutionsModel) => {
        const custValResults: CustomersMiniConversionValidationResultsClient = new CustomersMiniConversionValidationResultsClient();
        const polValResults: PoliciesMiniConversionValidationResultsClient = new PoliciesMiniConversionValidationResultsClient();
        const conValResults: ContactsMiniConversionValidationResultsClient = new ContactsMiniConversionValidationResultsClient();
        const actValResults: ActivitiesMiniConversionValidationResultsClient = new ActivitiesMiniConversionValidationResultsClient();
        custValResults.getResults(this.conversionId)
            .then(results => {
                this.setState({
                    custValResults: results!
                }, () => {
                    if (this.state.custValResults.length > 0) {
                        if (this.state.custValResults[0].errorCount === 0) {
                            this.setOption(MiniConstants.conversionOption_CustFileValidatedId, '1');
                        }
                    }
                })
            })
            .catch(error => { console.log('Error in getValidationResults (custValResults): ' + error); });
        polValResults.getResults(this.conversionId)
            .then(results => {
                this.setState({
                    polValResults: results!
                }, () => {
                    if (this.state.polValResults.length > 0) {
                        if (this.state.polValResults[0].errorCount === 0) {
                            this.setOption(MiniConstants.conversionOption_PolFileValidatedId, '1');
                        }
                    }
                })
            })
            .catch(error => { console.log('Error in getValidationResults (polValResults): ' + error); });
        conValResults.getResults(this.conversionId)
            .then(results => {
                this.setState({
                    conValResults: results!
                }, () => {
                    if (this.state.conValResults.length > 0) {
                        if (this.state.conValResults[0].errorCount === 0) {
                            this.setOption(MiniConstants.conversionOption_ContFileValidatedId, '1');
                        }
                    }
                })
            })
            .catch(error => { console.log('Error in getValidationResults (conValResults): ' + error); });
        actValResults.getResults(this.conversionId)
            .then(results => {
                this.setState({
                    actValResults: results!
                }, () => {
                    if (this.state.actValResults.length > 0) {
                        if (this.state.actValResults[0].errorCount === 0) {
                            this.setOption(MiniConstants.conversionOption_ActvFileValidatedId, '1');
                        }
                    }
                })
            })
            .catch(error => { console.log('Error in getValidationResults (actValResults): ' + error); });
    }

    openConfirmationModal = () => {
        this.setState({ confirmationModal: true })
    }

    openSubmitSuccessModal = () => {
        this.setOption(MiniConstants.conversionOption_CustFileQueuedId, '1');
        this.setOption(MiniConstants.conversionOption_PolFileQueuedId, '1');
        this.setOption(MiniConstants.conversionOption_ContFileQueuedId, '1');
        this.setOption(MiniConstants.conversionOption_ActvFileQueuedId, '1');
        this.setState({ submitSuccessModal: true })
    }

    openValidationFailureModal = () => {
        this.setState({ validationRunning: false, validationFailureModal: true })
    }

    openValidationSuccessModal = () => {
        this.setState({ validationRunning: false, validationSuccessModal: true })
    }

    refreshPage = (landingTab: TabName) => {
        store.dispatch(actionCreators.updateTab(landingTab))
        this.props.history.push({
            pathname: `/conversion/${this.conversionId}/${landingTab}`,
            state: { tabName: landingTab }
        });
    }

    gotoReports = () => {
        this.buttonLock();
        this.setState({ validationFailureModal: false });
        this.refreshPage('reports');
    }

    setOption = (optionId: string, optionValue: string) => {
        const optionsClient: ConversionOptionsClient = new ConversionOptionsClient();
        const optionModel: ConversionOptionValueModel[] = [];
        const valuesArray: any = {
            conversionId: this.conversionId,
            value: optionValue,
            isLocked: false,
            id: optionId,
        };
        optionModel.push(valuesArray);
        optionsClient.update(this.conversionId, optionModel);
        this.props.getOptions();
    }

    private submitMiniConversion = () => {
        const user = this.props.currentUser;
        if (this.conversionId && user) {
            this.conversionGenericClient.runMiniSubmitAction(this.conversionId, user.id!)
                .catch((e) => { console.log(e); });
            this.openSubmitSuccessModal();
        }
    }

    private validateRawData = () => {
        clearInterval(this.state.timeout);
        this.setState({
            timeout: setInterval(() => {
                this.setState({ buttonLock: true });
                this.setState({ validationRunning: true });
            }, 2000)
        })
        const user = this.props.currentUser;
        if (this.conversionId && user) {
            this.conversionGenericClient.runMiniValidationAction(this.conversionId, user.id!)
                .catch((e) => { console.log(e); });
        }
    }

    public render() {
        this.conversionId = this.props.match.params.conversionId;

        if (this.props.options) {
            for (const id of Object.keys(this.props.options)) {
                const value = this.props.options[id].value;
                switch (id.toUpperCase()) {
                    case MiniConstants.conversionOption_CustFileSelectedId: {
                        this.custFileSelected = (value === '1');
                        break;
                    }
                    case MiniConstants.conversionOption_CustFileUploadedId: {
                        this.custFileUploaded = (value === '1');
                        break;
                    }
                    case MiniConstants.conversionOption_CustFileValidatedId: {
                        this.custFileValidated = (value === '1');
                        break;
                    }
                    case MiniConstants.conversionOption_CustFileQueuedId: {
                        this.custFileQueued = (value === '1');
                        break;
                    }
                    case MiniConstants.conversionOption_PolFileSelectedId: {
                        this.polFileSelected = (value === '1');
                        break;
                    }
                    case MiniConstants.conversionOption_PolFileUploadedId: {
                        this.polFileUploaded = (value === '1');
                        break;
                    }
                    case MiniConstants.conversionOption_PolFileValidatedId: {
                        this.polFileValidated = (value === '1');
                        break;
                    }
                    case MiniConstants.conversionOption_PolFileQueuedId: {
                        this.polFileQueued = (value === '1');
                        break;
                    }
                    case MiniConstants.conversionOption_ContFileSelectedId: {
                        this.contFileSelected = (value === '1');
                        break;
                    }
                    case MiniConstants.conversionOption_ContFileUploadedId: {
                        this.contFileUploaded = (value === '1');
                        break;
                    }
                    case MiniConstants.conversionOption_ContFileValidatedId: {
                        this.contFileValidated = (value === '1');
                        break;
                    }
                    case MiniConstants.conversionOption_ContFileQueuedId: {
                        this.contFileQueued = (value === '1');
                        break;
                    }
                    case MiniConstants.conversionOption_ActvFileSelectedId: {
                        this.actvFileSelected = (value === '1');
                        break;
                    }
                    case MiniConstants.conversionOption_ActvFileUploadedId: {
                        this.actvFileUploaded = (value === '1');
                        break;
                    }
                    case MiniConstants.conversionOption_ActvFileValidatedId: {
                        this.actvFileValidated = (value === '1');
                        break;
                    }
                    case MiniConstants.conversionOption_ActvFileQueuedId: {
                        this.actvFileQueued = (value === '1');
                        break;
                    }
                    default: {
                        break;
                    }
                }
            }
        }

        if (this.state.validationRunning) {
            if (this.custFileUploaded && this.state.custValResults.length > 0 && this.state.custValResults[0].errorCount === 0 &&
                (!this.polFileUploaded || (this.polFileUploaded && this.state.polValResults.length > 0 && this.state.polValResults[0].errorCount === 0)) &&
                (!this.contFileUploaded || (this.contFileUploaded && this.state.conValResults.length > 0 && this.state.conValResults[0].errorCount === 0)) &&
                (!this.actvFileUploaded || (this.actvFileUploaded && this.state.actValResults.length > 0 && this.state.actValResults[0].errorCount === 0))) {
                store.dispatch(enqueueNotification({
                    type: 'success',
                    message: this.clientDescription + ' - ' + this.conversionDescription + ' - ' + this.execTitle + ' - ' + this.execDescription
                }))
                this.openValidationSuccessModal();
            }
            if ((this.custFileUploaded && this.state.custValResults.length > 0 && this.state.custValResults[0].errorCount > 0) ||
                (this.polFileUploaded && this.state.polValResults.length > 0 && this.state.polValResults[0].errorCount > 0) ||
                (this.contFileUploaded && this.state.conValResults.length > 0 && this.state.conValResults[0].errorCount > 0) ||
                (this.actvFileUploaded && this.state.actValResults.length > 0 && this.state.actValResults[0].errorCount > 0)) {
                store.dispatch(enqueueNotification({
                    type: 'error',
                    message: this.clientDescription + ' - ' + this.conversionDescription + ' - ' + this.execTitle + ' - Completed with Errors'
                }))
                this.openValidationFailureModal();
            }
        }

        const userLocale = navigator.language || navigator.languages[0];
        const date = this.state.delayedStart ? new Date(this.state.delayedStart!.executeAfterTime!) : null
        const time = date && date.toLocaleTimeString(userLocale);
        const delayedStart = this.state.delayedStart && this.state.delayedStart!.isDelayedStart || false;
        return (
            <>
                <div><p /></div>
                <h3 className='mapping-body-header'>Project Status</h3>

                {
                    //this.state.status === null &&
                    //  <h6 className='mapping-body-header'>
                    // Delayed Start :
                    //{delayedStart ?
                    //      `On - After: ${time}`
                    //      : "Off"}
                    //  </h6>
                }

                <Toolbar>
                    {
                        (this.state.validationRunning || this.state.submitRunning) &&
                        <img className='loading-indicator' src={'loader.gif'} />
                    }
                    <span>&nbsp;&nbsp;&nbsp;</span>
                    <Button
                        className='submit-button-orange'
                        disabled={!this.custFileUploaded || (this.polFileSelected && !this.polFileUploaded) || (this.contFileSelected && !this.contFileUploaded) || (this.actvFileSelected && !this.actvFileUploaded) || this.custFileQueued || this.state.buttonLock}
                        onClick={() => this.validateRawData()}>Validate</Button>
                    <span>&nbsp;&nbsp;&nbsp;</span>
                    <Button
                        className='submit-button-orange'
                        disabled={!this.custFileValidated || (this.polFileSelected && !this.polFileValidated) || (this.contFileSelected && !this.contFileValidated) || (this.actvFileSelected && !this.actvFileValidated) || this.custFileQueued || this.state.buttonLock}
                        onClick={() => this.openConfirmationModal()}>Submit</Button>
                </Toolbar>
                {this.state.status === null && this.custFileQueued && this.state.delayedStart && this.state.delayedStart!.isDelayedStart ?
                    <h6 className='status'><Badge color="primary">Conversion Queued for After: {time} </Badge> </h6>
                    : this.state.status}
                <DataTable>
                    <thead>
                        <tr>
                            <th>Name</th>
                            {!this.state.buttonLock &&
                                <th className='controls-column'></th>
                            }
                        </tr>
                    </thead>
                    <tbody>
                        {this.custFileSelected &&
                        <DataRow id='Customers' key='Customers'>
                            <DataCell>Customers Upload File</DataCell>
                                {!this.state.buttonLock && <DataCell>
                                    {!this.custFileUploaded ?
                                        <DataTableButton icon='file_upload' id='upload' title='Upload Pending' /> :
                                        <DataTableButton icon='done' id='upload' title='Upload Completed' />
                                    }
                                    {!this.custFileValidated ?
                                        <DataTableButton icon='settings' id='validate' title='Validation Pending' /> :
                                        <DataTableButton icon='done' id='validate' title='Validation Completed' />
                                    }
                                    {!this.custFileValidated ?
                                        <DataTableButton icon='visibility' id='reports' title='Reports Pending Validation' onClick={() => this.refreshPage('reports')} /> :
                                        <DataTableButton icon='visibility' id='reports' title='View Validation Reports' onClick={() => this.refreshPage('reports')} />
                                    }
                                    {!this.custFileQueued ?
                                        <DataTableButton icon='thumb_up' id='queue' title='Final Acceptance Pending' /> :
                                        <DataTableButton icon='done' id='queue' title='Queued for Processing' />
                                    }
                                    {this.custFileUploaded &&
                                        < DataTableButton icon='file_download' id='CustomerExportMini' title='Export Customer Upload File' action={() => this.exportToExcel('CustomerDIUUploadFileExport')} />
                                    }
                                </DataCell>}
                        </DataRow>
                        }
                        {this.polFileSelected &&
                            <DataRow id='Policies' key='Policies'>
                                <DataCell>Policies Upload File</DataCell>
                                {!this.state.buttonLock && <DataCell>
                                    {!this.polFileUploaded ?
                                        <DataTableButton icon='file_upload' id='upload' title='Upload Pending' /> :
                                        <DataTableButton icon='done' id='upload' title='Upload Completed' />
                                    }
                                    {!this.polFileValidated ?
                                        <DataTableButton icon='settings' id='validate' title='Validation Pending' /> :
                                        <DataTableButton icon='done' id='validate' title='Validation Completed' />
                                    }
                                    {!this.polFileValidated ?
                                        <DataTableButton icon='visibility' id='reports' title='Reports Pending Validation' onClick={() => this.refreshPage('reports')} /> :
                                        <DataTableButton icon='visibility' id='reports' title='View Validation Reports' onClick={() => this.refreshPage('reports')} />
                                    }
                                    {!this.polFileQueued ?
                                        <DataTableButton icon='thumb_up' id='queue' title='Final Acceptance Pending' /> :
                                        <DataTableButton icon='done' id='queue' title='Queued for Processing' />
                                    }
                                    {this.polFileUploaded &&
                                        < DataTableButton icon='file_download' id='PolicyExportMini' title='Export Policy Upload File' action={() => this.exportToExcel('PolicyDIUUploadFileExport')} />
                                    }
                                </DataCell>}
                            </DataRow>
                        }
                        {this.contFileSelected &&
                        <DataRow id='Contacts' key='Contacts'>
                            <DataCell>Contacts Upload File</DataCell>
                                {!this.state.buttonLock && <DataCell>
                                    {!this.contFileUploaded ?
                                        <DataTableButton icon='file_upload' id='upload' title='Upload Pending' /> :
                                        <DataTableButton icon='done' id='upload' title='Upload Completed' />
                                    }
                                    {!this.contFileValidated ?
                                        <DataTableButton icon='settings' id='validate' title='Validation Pending' /> :
                                        <DataTableButton icon='done' id='validate' title='Validation Completed' />
                                    }
                                    {!this.contFileValidated ?
                                        <DataTableButton icon='visibility' id='reports' title='Reports Pending Validation' onClick={() => this.refreshPage('reports')} /> :
                                        <DataTableButton icon='visibility' id='reports' title='View Validation Reports' onClick={() => this.refreshPage('reports')} />
                                    }
                                    {!this.contFileQueued ?
                                        <DataTableButton icon='thumb_up' id='queue' title='Final Acceptance Pending' /> :
                                        <DataTableButton icon='done' id='queue' title='Queued for Processing' />
                                    }
                                    {this.contFileUploaded &&
                                        < DataTableButton icon='file_download' id='ContactExportMini' title='Export Contact Upload File' action={() => this.exportToExcel('ContactDIUUploadFileExport')} />
                                    }
                                </DataCell>}                 
                        </DataRow>
                        }
                        {this.actvFileSelected &&
                        <DataRow id='Activities' key='Activities'>
                            <DataCell>Activities Upload File</DataCell>
                                {!this.state.buttonLock && <DataCell>
                                    {!this.actvFileUploaded ?
                                        <DataTableButton icon='file_upload' id='upload' title='Upload Pending' /> :
                                        <DataTableButton icon='done' id='upload' title='Upload Completed' />
                                    }
                                    {!this.actvFileValidated ?
                                        <DataTableButton icon='settings' id='validate' title='Validation Pending' /> :
                                        <DataTableButton icon='done' id='validate' title='Validation Completed' />
                                    }
                                    {!this.actvFileValidated ?
                                        <DataTableButton icon='visibility' id='reports' title='Reports Pending Validation' onClick={() => this.refreshPage('reports')} /> :
                                        <DataTableButton icon='visibility' id='reports' title='View Validation Reports' onClick={() => this.refreshPage('reports')} />
                                    }
                                    {!this.actvFileQueued ?
                                        <DataTableButton icon='thumb_up' id='queue' title='Final Acceptance Pending' /> :
                                        <DataTableButton icon='done' id='queue' title='Queued for Processing' />
                                    }
                                    {this.actvFileUploaded &&
                                        < DataTableButton icon='file_download' id='ActivityExportMini' title='Export Activity Upload File' action={() => this.exportToExcel('ActivityDIUUploadFileExport')} />
                                    }
                                </DataCell>}                          
                            </DataRow>}
                    </tbody>
                </DataTable>
                <CloseConfirmationModal
                    isOpen={this.state.validationFailureModal}
                    title={'File Validation Completed'}
                    message={'Validation has completed with errors. Would you like to review the validation reports for details?'}
                    onSubmit={this.gotoReports}
                    onClose={() => this.setState({ validationFailureModal: false }, () => this.buttonLock())}
                />
                <CloseConfirmationModal
                    isOpen={this.state.validationSuccessModal}
                    title={'File Validation Completed'}
                    message={'All data has been successfully validated. You may now submit your project for migration to the production environment.'}
                    onSubmit={() => this.setState({ validationSuccessModal: false }, () => this.buttonLock())}
                    onClose={() => this.setState({ validationSuccessModal: false }, () => this.buttonLock())}
                />
                <CloseConfirmationModal
                    isOpen={this.state.confirmationModal}
                    title={'Confirmation'}
                    message={delayedStart ? 'Are you sure you want to add this data import to the queue? Queue runs nightly at ' + time : 'Are you sure you want to add this data import to the queue?'}
                    onSubmit={() => this.setState({ confirmationModal: false }, () => this.submitMiniConversion())}
                    onClose={() => this.setState({ confirmationModal: false }, () => this.buttonLock())}
                />
                <CloseConfirmationModal
                    isOpen={this.state.submitSuccessModal}
                    title={'Project Submitted'}
                    message={'Your project has been successfully submitted for migration to the production environment.'}
                    onSubmit={() => this.setState({ submitSuccessModal: false }, () => this.buttonLock())}
                    onClose={() => this.setState({ submitSuccessModal: false }, () => this.buttonLock())}
                />
            </>
        )
    }
}

export default withRouter(ConversionMiniDashPage)
